export const getFortpixelProjectsPath = () => "fortpixelData/projects";
export const getFortpixelExpensesPath = () => "fortpixelData/expenses";
export const getFortpixelEarningsPath = () => "fortpixelData/earnings";
export const getFortpixelVerifiedPurchasesPath = () =>
  "fortpixelData/verifiedPurchases";
export const getFortpixelUserInputsPath = (uid) =>
  `fortpixelData/userInputs/${uid}`;
export const getFortpixelVerifiedPurchaseTogglesPath = (uid) =>
  `fortpixelData/verifiedPurchaseToggles/${uid}`;
